import axios from 'axios';

export const deleteDrugClass = async (drugClass) => {
  const url = `${process.env.REACT_APP_API_URL}/drug_classes/${drugClass.id}`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.delete(url,{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


